export default __webpack_public_path__ + "img/WB_RT_250MA_EF.be1d92a791f10ab4cf271ebdf18eaf42.jpg";